import { SvgProps } from '@/interfaces/SvgProps';
import ChevronDown from './base-components/ChevronDown';
import EN from './base-components/en';
import NL from './base-components/nl';
import ArrowRight from './base-components/ArrowRight';
import SearchMd from './base-components/Search';
import Phone from './base-components/Phone';
import Mail01 from './base-components/Mail';
import PlusCircle from './base-components/PlusCircle';
import Infinity from './base-components/infinity';
import SearchRefraction from './base-components/search-refraction';
import MessageSmileCircle from './base-components/message-smile-circle';
import Award03 from './base-components/award-03';
import File07 from './base-components/file-07';
import FileCheck02 from './base-components/file-check-02';
import ShieldTick from './base-components/shield-tick';
import Coins04 from './base-components/coins-04';
import FastForward from './base-components/fast-forward';
import SkipForward from './base-components/skip-forward';
import Scales02 from './base-components/scales-02';
import NavigationPointer01 from './base-components/NavigationPointer';
import MarkerPin01 from './base-components/MarkerPin';
import Briefcase01 from './base-components/BriefCase';
import Bookmark from './base-components/Bookmark';
import CurrencyEuro from './base-components/Euro';
import Clock from './base-components/Clock';
import Building07 from './base-components/Building-07';
import File02 from './base-components/File';
import Check from './base-components/Check';
import UploadCloud02 from './base-components/Cloud';

interface IconProps extends SvgProps {
  name: string;
}

// Remove this static import, make the icon import dynamic
const iconMap: { [key: string]: React.FC<SvgProps> } = {
  'chevron-down': ChevronDown,
  'arrow-right': ArrowRight,
  search: SearchMd,
  en: EN,
  nl: NL,
  phone: Phone,
  mail: Mail01,
  'plus-circle': PlusCircle,
  infinity: Infinity,
  'search-refraction': SearchRefraction,
  'message-smile': MessageSmileCircle,
  award: Award03,
  file: File07,
  'file-check': FileCheck02,
  shield: ShieldTick,
  coins: Coins04,
  'fast-forward': FastForward,
  skip: SkipForward,
  scale: Scales02,
  navigation: NavigationPointer01,
  marker: MarkerPin01,
  briefcase: Briefcase01,
  bookmark: Bookmark,
  euro: CurrencyEuro,
  clock: Clock,
  building: Building07,
  'file-icon': File02,
  check: Check,
  cloud: UploadCloud02,
};

const Icon: React.FC<IconProps> = ({ name, className, style, ...restProps }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    return null; // Optionally render a fallback UI
  }

  return <IconComponent className={className} style={style} {...restProps} />;
};

export default Icon;
